import { z } from "zod";
import { telemetryDataProviderSchema } from "../_shared";

export const fetchVehiclesTripsPayloadSchema = z.object({
  page: z.number().optional(),
  page_size: z.number().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  dataProvider: telemetryDataProviderSchema,
  isSendingNotification: z.boolean().optional(),
});

export type FetchVehiclesTripsPayload = z.infer<
  typeof fetchVehiclesTripsPayloadSchema
>;
